///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SuiCustomerRestrictionsDTO } from '../../../generated/shared-sui-types.model';
import { CustomerRestrictionsDTO } from '../../../generated/shared-types.model';

@Injectable()
export class CustomerRestrictionsService {
    private readonly resourceUrl = 'api/customer-restrictions';

    constructor(private readonly http: HttpClient) {}

    query(): Observable<SuiCustomerRestrictionsDTO> {
        return this.http
            .get<CustomerRestrictionsDTO>(this.resourceUrl)
            .pipe(map((restrictions: CustomerRestrictionsDTO) => new SuiCustomerRestrictionsDTO(restrictions)));
    }

    update(companyType: SuiCustomerRestrictionsDTO): Observable<SuiCustomerRestrictionsDTO> {
        return this.http.put<CustomerRestrictionsDTO>(this.resourceUrl, companyType.toDto()).pipe(
            map((customerRestrictionsDto) => new SuiCustomerRestrictionsDTO(customerRestrictionsDto)),
            catchError(() => {
                return of(undefined);
            })
        );
    }
}
